import React from 'react';
import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import { MarketplaceGrid } from '@features/connections/generic/components/MarketplaceGrid';
import { useTutorialStore } from '../../../application/store/TutorialStore';
import { APP_CONFIG } from '../../../config/app.config';
import { Icon, IconSize } from '@shared/icons';
import OnboardingStepCard from '../shared/OnboardingStepCard';

interface ConnectStoreStepProps {
  onContinue: () => void;

}

const ConnectStoreStep: React.FC<ConnectStoreStepProps> = ({ onContinue }) => {
  const colors = APP_CONFIG.ui.theme.colors;
  const { markStepCompleted } = useTutorialStore();

  const handleNewConnection = () => {
    markStepCompleted('marketplace-connection');
    onContinue();
  };

  return (
    <OnboardingStepCard
      title="Connect to your store"
      subtitle="Be able to see all the data available"
      isActive
      footer={
        <Stack
          direction="row"
          flex={1}
          gap={1}
        >
          <Icon icon="AlertCircle" size={IconSize.MEDIUM} color={colors.secondaryText} />
          <Typography variant="body2" color={colors.secondaryText} >
            We load all your data needed to start automatically from your store
          </Typography>
        </Stack>
      }
    >
      <MarketplaceGrid onNewConnection={handleNewConnection} />
    </OnboardingStepCard>
  );
};

export default ConnectStoreStep;
